import { Component } from '@angular/core';

import { ShutdownDeviceBaseDirective } from './shutdown-device.base.directive';
import { NgClass } from '@angular/common';

@Component({
  selector: 'ml-mdm-shutdown-device',
  templateUrl: './shutdown-device.component.html',
  imports: [NgClass],
})
export class ShutdownDeviceComponent extends ShutdownDeviceBaseDirective {}
